export * from './IndependentCornersIcon';
